module.exports = __webpack_public_path__ + "static/media/gym8.c8515853.jpg";